export const getParameter = (name, instring) => {
	    const n = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]"),
	    	instr = instring || window.location.href,
			regexS = "[\\?&]" + n + "=([^&#]*)",
			regex = new RegExp(regexS),
			results = regex.exec(instr)
	    return (results == null) ? "" : decodeURIComponent(results[1].replace(/\+/g, " "))
	}
